module.exports = __webpack_public_path__ + "static/media/CSI Logo.1debbb0c.PNG";